import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Container, i18n, ModalService, Service } from '../../../../symphony';

import { MailingContext } from '../../contexts';
import { MailingDataService } from './mailing-data.service';
import {
  IContactMailData,
  IContactMailResponse,
  IMailingApi, IPrivacyRequestData, IPrivacyRequestResponse, ITeamsRequestData, ITeamsRequestResponse, MailingApi,
} from '../../../../api/public/mailing-api';

@Service()
export class MailingApiService {
  private mailingApi: IMailingApi;

  private modalService: ModalService;

  constructor() {
    this.mailingApi = Container.take('global', MailingApi);
    this.modalService = Container.take('global', ModalService);
  }

  public sendPrivacyRequestHandler(
    payload: IPrivacyRequestData,
  ): Observable<IPrivacyRequestResponse> {
    const { loading$, modalMessage$ } = Container.take(
      MailingContext,
      MailingDataService,
    );
    loading$.next(true);
    return this.mailingApi.sendPrivacyRequest(payload).pipe(
      tap(() => {
        this.modalService.open('privacyRequestModal');
        loading$.next(false);
        modalMessage$.next({
          type: 'success',
          message: 'Thank you for getting in touch! Your form was successfully submitted and we will respond to you soon.',
        });
      }),
      catchError(() => {
        this.modalService.open('privacyRequestModal');
        loading$.next(false);
        modalMessage$.next({
          type: 'fail',
          message: 'Oops! Something went wrong. Please re-submit your form or send us an email at info@sololearn.com.',
        });
        return of(null);
      }),
    );
  }

  public sendContactMailHandler(
    payload: IContactMailData,
  ): Observable<IContactMailResponse> {
    const { loading$, modalMessage$ } = Container.take(
      MailingContext,
      MailingDataService,
    );
    loading$.next(true);
    return this.mailingApi.sendContactMail(payload).pipe(
      tap(() => {
        this.modalService.open('contactMailModal');
        loading$.next(false);
        modalMessage$.next({
          type: 'success',
          message: i18n.t('contact-us.message.success'),
        });
      }),
      catchError(() => {
        this.modalService.open('contactMailModal');
        loading$.next(false);
        modalMessage$.next({
          type: 'fail',
          message: i18n.t('contact-us.message.failure'),
        });
        return of(null);
      }),
    );
  }

  public sendTeamsRequestHandler(
    payload: ITeamsRequestData,
  ): Observable<ITeamsRequestResponse> {
    const { teamsLoading$, teamsModal$ } = Container.take(
      MailingContext,
      MailingDataService,
    );
    teamsLoading$.next(true);
    return this.mailingApi.sendTeamsRequest(payload).pipe(
      tap(() => {
        teamsModal$.next('success');
        teamsLoading$.next(false);
      }),
      catchError(() => {
        teamsModal$.next('fail');
        teamsLoading$.next(false);
        return of(null);
      }),
    );
  }

  public sendClassroomRequestHandler(
    payload: any,
  ) {
    return this.mailingApi.sendClassroomRequest(payload);
  }
}
